import React from "react";

function MultipleChoice({value = '', selected = 'no', clicked}) {
  return (
    <label className="multiple-choice-label">
      <input
        type="checkbox"
        className="multiple-choice-check"
        checked={selected === value}
        onChange={() => clicked(value)}
      />
      {value}
    </label>
  )
}

export default MultipleChoice;
